import { render } from "./IgnoreNode.vue?vue&type=template&id=19441187&scoped=true"
import script from "./IgnoreNode.vue?vue&type=script&lang=js"
export * from "./IgnoreNode.vue?vue&type=script&lang=js"

import "./IgnoreNode.vue?vue&type=style&index=0&id=19441187&scoped=true&lang=css"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19441187"]])

export default __exports__